/**
 * @copyright 2023 Nuance Communications Inc.
 * All Rights Reserved.
 */

export interface IHollowCheckMarkSVGProps {
    themedColor: string;
}

/**
 * @description HollowCheckMarkSVG component contains SVG for Check mark icon
 * @returns The HollowCheckMarkSVG component.
 */
export const HollowCheckMarkSVG = (props: IHollowCheckMarkSVGProps) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.00065 1.33333C11.6825 1.33333 14.6673 4.3181 14.6673 8C14.6673 11.6819 11.6825 14.6667 8.00065 14.6667C4.31875 14.6667 1.33398 11.6819 1.33398 8C1.33398 4.3181 4.31875 1.33333 8.00065 1.33333ZM8.00065 2.33333C4.87104 2.33333 2.33398 4.87039 2.33398 8C2.33398 11.1296 4.87104 13.6667 8.00065 13.6667C11.1302 13.6667 13.6673 11.1296 13.6673 8C13.6673 4.87039 11.1302 2.33333 8.00065 2.33333ZM7.16732 8.95953L10.1471 5.97978C10.3424 5.78452 10.6589 5.78452 10.8542 5.97978C11.0317 6.15729 11.0479 6.43507 10.9026 6.63081L10.8542 6.68687L7.52085 10.0202C7.34338 10.1977 7.06558 10.2139 6.86985 10.0686L6.81378 10.0202L5.1471 8.35353C4.95184 8.15827 4.95184 7.84173 5.1471 7.64647C5.32461 7.46893 5.60238 7.4528 5.79812 7.59807L5.8542 7.64647L7.16732 8.95953L10.1471 5.97978L7.16732 8.95953Z"
                fill={props.themedColor}
            />
        </svg>
    );
};
